import { toJcamps } from './toJcamps';
/**
 * converts an analysis to a jcamp string
 *
 * @param analysis
 * @param options
 * @returns Jcamp text file containing the analysis
 */
export function toJcamp(analysis, options = {}) {
    return toJcamps(analysis, options).join('\n');
}
//# sourceMappingURL=toJcamp.js.map